// var url = '{{ template }}pdf/3d.pdf';

let pdfDoc = null,
    pageNum = 1,
    pageRendering = false,
    pageNumPending = null,
    scale = 1.5, // Масштабування сторінки
    canvas = document.getElementById('pdf-canvas'),
    ctx = canvas.getContext('2d');
canvas.style.opacity = 0;

// Завантаження PDF-документа
const loadingTask = pdfjsLib.getDocument(url);


loadingTask.onProgress = function(data){
    const invisibleElements = document.querySelectorAll('.invisible');
    const spinner = document.getElementsByClassName('spinner-pdf')[0];

    if (data.loaded === data.total) {
        spinner.classList.add('d-none');
        for(let el of invisibleElements) {
            console.log(el)
            el.classList.remove('invisible');
        }
    }
}
loadingTask.promise.then(function(pdfDoc_) {
    pdfDoc = pdfDoc_;
    document.getElementById('page-count').textContent = pdfDoc.numPages;

    // Відображення першої сторінки
    renderPage(pageNum);
});
// Функція для рендерингу сторінки
function renderPage(num) {
    pageRendering = true;

    // Отримання сторінки
    pdfDoc.getPage(num).then(function(page) {
        let viewport = page.getViewport({ scale: scale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Рендер сторінки у canvas
        let renderContext = {
            canvasContext: ctx,
            viewport: viewport
        };
        let renderTask = page.render(renderContext);

        // Очікуємо завершення рендерингу
        renderTask.promise.then(function() {
            pageRendering = false;

            if (pageNumPending !== null) {
                renderPage(pageNumPending);
                pageNumPending = null;

            }
            setTimeout(function() {
                canvas.style.opacity = 1;
            }, 200);
        });
    });

    // Оновлення номера сторінки
    document.getElementById('page-num').textContent = num;
}

// Перемикання на наступну сторінку
function queueRenderPage(num) {
    canvas.style.opacity = 0;
    setTimeout(function() {
        if (pageRendering) {
            pageNumPending = num;
        } else {
            renderPage(num);
        }
    }, 100);

}

// Переходи по сторінкам
document.getElementById('first-page').addEventListener('click', function() {
    canvas.style.opacity = 0;
    if (pageNum <= 1) {
        canvas.style.opacity = 1
        return;
    }
    pageNum = 1;
    queueRenderPage(pageNum);
});

document.getElementById('last-page').addEventListener('click', function() {
    canvas.style.opacity = 0;

    pageNum = pdfDoc.numPages;
    queueRenderPage(pageNum);
});
document.getElementById('prev-page').addEventListener('click', function() {
    canvas.style.opacity = 0;
    if (pageNum <= 1) {
        canvas.style.opacity = 1
        return;
    }
    pageNum--;
    queueRenderPage(pageNum);
});

document.getElementById('next-page').addEventListener('click', function() {
    canvas.style.opacity = 0;
    if (pageNum >= pdfDoc.numPages) {
        canvas.style.opacity = 1
        return;
    }
    pageNum++;
    queueRenderPage(pageNum);
});